// extracted by mini-css-extract-plugin
export default {"buttons":"Map_buttons__sVXE+","right":"Map_right__bSRGt","map":"Map_map__7doVP","info":"Map_info__505jm","message":"Map_message__HjFzJ"};